<template>
    <v-container fluid>   
      
    </v-container>
</template>

<script>
export default {
  name: 'TestModule',
  components: {
  },

  data () {
      return { 
      }
    },
  mounted: function ()  {

  },
  methods: {
  }
  }
</script>